/** Doc ids under `participant/{uid}/ranking/{docId}`. */
export const RankingDocId = {
    INDIVIDUAL: "individual",
    TEAM: "team",
} as const;

export type RankingDocId = (typeof RankingDocId)[keyof typeof RankingDocId];

/** `participant/{uid}/ranking/individual` — private snapshot for individual UI. */
export type IndividualRankingScore = {
    score: number;
    updatedAt?: Date;
};

/** `participant/{uid}/ranking/team` — private snapshot for team contribution UI. */
export type TeamRankingScore = {
    score: number;
    updatedAt?: Date;
};

/** Both ranking docs as loaded for the admin participant action. */
export type ParticipantRanking = {
    individual: IndividualRankingScore | null;
    team: TeamRankingScore | null;
};

export const emptyIndividualRankingScore = (): IndividualRankingScore => ({
    score: 0,
});

export const emptyTeamRankingScore = (): TeamRankingScore => ({
    score: 0,
});
